import {
	GetWaitingPeriodUrl,
	GetWaitingPeriodUrlModel,
} from 'domain/usecases/private/external-links/waiting-period/get-waiting-period';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteGetWaitingPeriodUrl implements GetWaitingPeriodUrl {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetWaitingPeriodUrlModel>,
	) {}

	async get(): Promise<GetWaitingPeriodUrlModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
